import 'lib/vendor/snowplow';

// #region Types
declare global {
  interface Window {
    snowplow: unknown
  }
}

export type UserStateSchemaData = {
  pageviewGuid:string
  botScore?:number|null
  errorText?:string
  fingerprint:string
  flags?:string
  ja3Hash?:string|null
  jsDetectPassed?:boolean|null
  signInType?:string|null
  splitTestName?:string|null
  splitTestVariant?:string|null
  statusStart?:string
  statusUpdated?:string
  userAuthId?:string|null
  verifiedBot?:boolean|null
}

export type UserState = {
  schema:string,
  data: UserStateSchemaData
}[]

export type ResourceImpressionsData = {
  ids:number[]
  pros:number[]
  page?:number
}

export type TurbolinksTimingData = {
  visitDur:number
  reqDur:number
  prevUrl:string
  visitNo:number
}

export type WebVitalsReportDataEntry = {
  sTime:number
  name?:string
  dur?:number
  sProcess?:number
  eProcess?:number
  val?:number
  url?:string
  el?:string
  load?:number
  render?:number
  recentIn?:boolean
  lastIn?:number
  els?:string[]
}

export type WebVitalsReportData = {
  name:string
  val:number
  entries:WebVitalsReportDataEntry[]
}
// #endregion

const { snowplow: sp } = window;

/*
* Note: The installed version of Typescript does not support typing
* overloaded functions with different argument structures well.
* When that is supported, please type Snowplow more directly.
* Until then, the proxy methods will be typed as correctly
* as they can be.
*/

const trackSelfDescribingEvent = ({
  schema,
  eventData,
  userStateData,
}:{
  schema:string,
  eventData:ResourceImpressionsData|TurbolinksTimingData|WebVitalsReportData,
  userStateData:UserState
}) => {
  /* eslint-disable */
  // @ts-ignore
  sp('trackSelfDescribingEvent', {
    schema,
    data: eventData,
  }, userStateData);
  /* eslint-enable */
};

const trackStructEvent = ({
  category,
  action,
  label = '',
  property = null,
  value = null,
  customContext = null,
}) => {
  /* eslint-disable */
  // @ts-ignore
  sp('trackStructEvent',
    category,
    action,
    label,
    property,
    value,
    customContext);
  /* eslint-enable */
};

const trackPageView = ({
  title = null,
  customContext = [],
  contextFunc = null,
}) => {
  /* eslint-disable */
  // @ts-ignore
  sp('trackPageView',
    title,
    customContext,
    contextFunc);
  /* eslint-enable */
};

const newTracker = ({
  namespace,
  collectorEndpoint,
  config = {},
}) => {
  /* eslint-disable */
  // @ts-ignore
  sp('newTracker',
    namespace,
    collectorEndpoint,
    config);
  /* eslint-enable */
};

const setUserIdFromCookie = ({ cookieId }) => {
  /* eslint-disable */
  // @ts-ignore
  sp('setUserIdFromCookie', cookieId);
  /* eslint-enable */
};

const enableActivityTracking = ({
  minimumVisitLength,
  heartbeatDelay,
}) => {
  /* eslint-disable */
  // @ts-ignore
  sp('enableActivityTracking', minimumVisitLength, heartbeatDelay);
  /* eslint-enable */
};

// More options exist but we're not using them. Please view Snowplow docs for additional argument info
const enableLinkClickTracking = () => {
  /* eslint-disable */
  // @ts-ignore
  sp('enableLinkClickTracking');
  /* eslint-enable */
};

const Snowplow = {
  trackSelfDescribingEvent,
  trackStructEvent,
  trackPageView,
  newTracker,
  setUserIdFromCookie,
  enableActivityTracking,
  enableLinkClickTracking,
};

export default Snowplow;
